module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 112.b545886d.png";